import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";
import store from "./store";

Vue.config.productionTip = false;

const firebase_configuration_options = {
    apiKey: "AIzaSyCOyXGSsUi4SUi1TBIo2f55vS6FHeaRxTk",
    authDomain: "diario-2cc8f.firebaseapp.com",
    databaseURL: "https://diario-2cc8f.firebaseio.com",
    projectId: "diario-2cc8f",
    storageBucket: "diario-2cc8f.appspot.com",
    messagingSenderId: "476140951648",
    appId: "1:476140951648:web:1575a43796e3f0f1854b05"
};

firebase.initializeApp(firebase_configuration_options);
firebase.auth().onAuthStateChanged(user => {
    store.dispatch("fetchUser", user);
});

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
